import {IComponentOptions, ILogService} from "angular";
import {IModalInstanceService} from "angular-ui-bootstrap";
import {LoadingService} from "../../shared/loading/loading.service";
import {ApplicationService} from "../../shared/application/application.service";
import {ApplicationCreditSummary} from "../../shared/model/ApplicationCreditSummary";

class DeclineCreditModalController {
    public modalInstance: IModalInstanceService;
    public resolve: any;
    public close: any;
    public dismiss: any;
    public applicationSummary: ApplicationCreditSummary;

    /* @ngInject */
    constructor(private $log: ILogService,
                private toaster: any,
                private loadingService: LoadingService,
                private applicationService: ApplicationService) {
    }

    public $onInit() {
        this.applicationSummary = this.resolve.applicationSummary;
    }

    public decline() {
        this.loadingService.show();

        this.applicationService.declineByStudent(this.applicationSummary.application)
            .then((updatedApplication) => {
                this.applicationSummary.application = updatedApplication;
                this.toaster.pop({type: "success", title: "We confirm your rejection of credit for your Monash University course. Your student record will be updated accordingly"});
                this.close({$value: updatedApplication});
            }).finally(() => {
            this.loadingService.hide();
        });
    }

    public cancel() {
        this.dismiss({$value: "cancel"});
    }
}

export const DeclineCreditModalComponent: IComponentOptions = {
    bindings: {
        modalInstance: "<",
        resolve: "<",
        close: "&",
        dismiss: "&"
    },
    controller: DeclineCreditModalController,
    template: require("./decline-credit-modal.html")
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/student/decline-credit-modal/decline-credit-modal.component.ts